import { Box, SimpleGrid } from '@chakra-ui/react';
import { Formik, Form } from 'formik';
import { constructYupSchema } from './helpers';
import {
  FormCustomError,
  FormItem,
  FormikOnChangeObserver,
} from './components';
import React from 'react';

// One key per item, by the field it is rather than the slot it sits in.
//
// A name repeated across the config — the same field in two sections, or a
// layout item carrying none — would key two siblings the same, and React
// resolves that by reusing the wrong subtree, which is the bug this keying
// exists to avoid. Those fall back to the position (review of #7078).
const itemKeys = (config) => {
  const seen = new Set();
  return config.map((item, index) => {
    const name = item?.name;
    if (!name || seen.has(name)) return `i-${index}`;
    seen.add(name);
    return `f-${name}`;
  });
};

export const FormBuilder = ({
  formRef,
  config = [],
  initialValues = {},
  onSubmit = undefined,
  errorMessage = '',
  showCustomError = false,
  observFunc = undefined,
  isObserveEnabled = false,
  formContainerProps = {},
  hasFormChild = false,
  useGridStyles = false,
  FormChild = () => <></>,
}) => {
  if (!config || config.length === 0) return null;

  const formSchema = constructYupSchema(config);

  return (
    <Box pos="relative" {...formContainerProps}>
      <Formik
        enableReinitialize
        innerRef={formRef}
        initialValues={initialValues}
        validationSchema={formSchema}
        onSubmit={onSubmit ? onSubmit : () => {}}
      >
        {(formik) => (
          <Form>
            {showCustomError && (
              <FormCustomError formik={formik} errorMessage={errorMessage} />
            )}
            <SimpleGrid columns={1} spacingY={useGridStyles ? '1em' : 0}>
              {itemKeys(config).map((key, index) => (
                // Keyed by the field itself, not its position. The offer
                // config settles after the form has mounted, and an index key
                // made the item at a given slot become a different field —
                // React reused the subtree, tearing down a live rich-text
                // editor under kula's table bubble menu and taking the page
                // down with it (Venil, QA sanity round 1).
                <React.Fragment key={key}>
                  <FormItem
                    field={config[index]}
                    formik={formik}
                    useGridStyles={useGridStyles}
                  />
                </React.Fragment>
              ))}
            </SimpleGrid>
            {isObserveEnabled && (
              <FormikOnChangeObserver
                onChange={observFunc ? observFunc : () => {}}
                delay={0}
              />
            )}
            {hasFormChild && <FormChild />}
          </Form>
        )}
      </Formik>
    </Box>
  );
};
